import { readConsent, storedVisitId } from "./analytics/consent";
import { vendorConfig } from "./analytics/vendors";

export const AUTH_ORIGINS = Object.freeze({
  global: "https://auth.blenderbridge.com",
  ru: "https://auth.blenderbridge.ru",
});
const LANGUAGES = new Set(["en", "ru", "de", "fr", "es", "pt", "tr", "ja", "zh", "ko", "ar", "hi", "bn", "id", "vi"]);

export function regionalAccountHref(raw: string, hostname: string, language: string): string | null {
  let url: URL;
  try { url = new URL(raw); } catch { return null; }
  if (!Object.values(AUTH_ORIGINS).some(origin => origin === url.origin)
        // `/account` здесь потому, что шапка сайта превращается в него, когда
    // человек уже вошёл: без этого ссылка осталась бы на чужом контуре.
    || url.username || url.password
    || !["/", "/login", "/register", "/account"].includes(url.pathname)) return null;
  const host = hostname.toLowerCase();
  const origin = host === "blenderbridge.ru" || host === "www.blenderbridge.ru" ? AUTH_ORIGINS.ru
    : host === "blenderbridge.com" || host === "www.blenderbridge.com" ? AUTH_ORIGINS.global : url.origin;
  const result = new URL(url.pathname, origin);
  const lang = language.toLowerCase().split(/[-_]/)[0] || "en";
  result.searchParams.set("lang", LANGUAGES.has(lang) ? lang : "en");
  if (url.searchParams.get("trial") === "1") result.searchParams.set("trial", "1");
  return result.href;
}

export function installAccountLinks(view: Window): void {
  const doc = view.document;
  const update = (anchor: HTMLAnchorElement): void => {
    const href = regionalAccountHref(anchor.href, view.location.hostname, doc.documentElement.lang);
    if (href) {
      const url=new URL(href);
      if(import.meta.env.VITE_BB_ANALYTICS_ENABLED === "true") {
        try {
          const allowed=readConsent(view.localStorage,vendorConfig(view.location.hostname).revision)==="granted";
          const id=allowed ? storedVisitId(view.localStorage) : null;
          url.searchParams.set("v",id ?? "0");
        } catch { url.searchParams.set("v","0"); }
      }
      anchor.href=url.href;
    }
  };
  const updateAll = (): void => doc.querySelectorAll<HTMLAnchorElement>("a[href]").forEach(update);
  updateAll();
  // The existing locale service can set <html lang> without dispatching an event.
  const languageObserver = new MutationObserver(updateAll);
  languageObserver.observe(doc.documentElement, { attributes: true, attributeFilter: ["lang"] });
  // Offers can render after localization; update the actual link before navigation.
  for (const event of ["click", "auxclick", "contextmenu"]) {
    doc.addEventListener(event, e => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const anchor = target.closest<HTMLAnchorElement>("a[href]");
      if (anchor) update(anchor);
    }, true);
  }
}

export function regionalAccountHtml(html: string, region: "ru" | "global"): string {
  // Static links must work on the correct server even when scripts are unavailable.
  return html.replace(/href="https:\/\/auth\.blenderbridge\.(?:com|ru)(?=[/"?])/g,
    `href="${AUTH_ORIGINS[region]}`);
}
